module.exports = __webpack_public_path__ + "img/visa-white.aa02ebc5.svg";